module.exports = __webpack_public_path__ + "img/h5img7.498309b4.png";